// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { alertsClasses as myClasses } from "src/controllers/alerts";

import { HTMLDivProps, Text } from "@blueprintjs/core";
import { Classes } from "src/mpd-library";

import { MoreInfo } from "src/controllers/alerts/components";

import { Select } from 'src/components';

import "./styles.css";

export interface IPawsDetailsProps extends HTMLDivProps {
  iPawsDetails: any;
  onToggleMoreInfo(event: any, type: string): void;
  onIPawsSelectChanged(event: any, type: string): void;
}

export const PawsDetails: React.SFC<IPawsDetailsProps> = props => {
  const {
    className,
    iPawsDetails,
    onToggleMoreInfo,
    onIPawsSelectChanged
  } = props;

  const {
    moreInfo,
    category,
    eventCode,
    urgency,
    certainty,
    responseType,
    timeZone
  } = iPawsDetails;

  const classes = classNames(
    myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER,
    "ipaws-container",
    className
  );

  return (
    <div className={classes}>
      <div
        className={classNames(myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER)}
      >
        <div className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE_CONTAINER}>
          <Text className={myClasses.ALERTS_CONTENT_COMPOSE_SUBTITLE}>
            IPAWS DETAILS
          </Text>
          <MoreInfo onClick={(e: any) => onToggleMoreInfo(e, "iPawsDetails")} />
        </div>
      </div>
      <div
        className={classNames(myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER)}
      >
        <div
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER
          )}
        >
          <Text className={myClasses.ALERTS_CONTENT_COMPOSE_INNER_SUBTITLE}>
            Category
          </Text>
          <Select
            className="compose-select"
            value={category && category.value}
            options={["Safety", "Non"]}
            onChange={e => onIPawsSelectChanged(e, "category")}
          />
        </div>
        <Text
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_MORE_INFO,
            moreInfo && Classes.ACTIVE
          )}
        >
          This can be a hint that shows the user what to put here when they
          select the “i” button next to Message Details. On mobile, this could
          show up below the input
        </Text>
      </div>
      <div
        className={classNames(myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER)}
      >
        <div
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER
          )}
        >
          <Text className={myClasses.ALERTS_CONTENT_COMPOSE_INNER_SUBTITLE}>
            Event Code
          </Text>
          <Select
            className="compose-select"
            value={eventCode && eventCode.value}
            options={["lew", "dew", "new", "boo"]}
            onChange={e => onIPawsSelectChanged(e, "eventCode")}
          />
        </div>
        <Text
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_MORE_INFO,
            moreInfo && Classes.ACTIVE
          )}
        >
          This can be a hint that shows the user what to put here when they
          select the “i” button next to Message Details. On mobile, this could
          show up below the input
        </Text>
      </div>
      <div
        className={classNames(myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER)}
      >
        <div
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER
          )}
        >
          <Text className={myClasses.ALERTS_CONTENT_COMPOSE_INNER_SUBTITLE}>
            Urgency
          </Text>
          <Select
            className="compose-select"
            value={urgency && urgency.value}
            options={["Immediate", "Temporary"]}
            onChange={e => onIPawsSelectChanged(e, "urgency")}
          />
        </div>
        <Text
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_MORE_INFO,
            moreInfo && Classes.ACTIVE
          )}
        >
          This can be a hint that shows the user what to put here when they
          select the “i” button next to Message Details. On mobile, this could
          show up below the input
        </Text>
      </div>
      <div
        className={classNames(myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER)}
      >
        <div
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER
          )}
        >
          <Text className={myClasses.ALERTS_CONTENT_COMPOSE_INNER_SUBTITLE}>
            Certainty
          </Text>
          <Select
            className="compose-select"
            value={certainty && certainty.value}
            options={["Observed", "Non-observed"]}
            onChange={e => onIPawsSelectChanged(e, "certainty")}
          />
        </div>
        <Text
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_MORE_INFO,
            moreInfo && Classes.ACTIVE
          )}
        >
          This can be a hint that shows the user what to put here when they
          select the “i” button next to Message Details. On mobile, this could
          show up below the input
        </Text>
      </div>
      <div
        className={classNames(myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER)}
      >
        <div
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER
          )}
        >
          <Text className={myClasses.ALERTS_CONTENT_COMPOSE_INNER_SUBTITLE}>
            Reponse Type
          </Text>
          <Select
            className="compose-select"
            value={responseType && responseType.value}
            options={["Shelter, not-sheltered"]}
            onChange={e => onIPawsSelectChanged(e, "responseType")}
          />
        </div>
        <Text
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_MORE_INFO,
            moreInfo && Classes.ACTIVE
          )}
        >
          This can be a hint that shows the user what to put here when they
          select the “i” button next to Message Details. On mobile, this could
          show up below the input
        </Text>
      </div>
      <div
        className={classNames(myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_CONTAINER)}
      >
        <div
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_BLOCK_INNER_CONTAINER
          )}
        >
          <Text className={myClasses.ALERTS_CONTENT_COMPOSE_INNER_SUBTITLE}>
            Timezone
          </Text>
          <Select
            className="compose-select"
            value={timeZone && timeZone.value}
            category={"timeZone"}
            options={["Central timezone"]}
            onChange={e => onIPawsSelectChanged(e, "timeZone")}
          />
        </div>
        <Text
          className={classNames(
            myClasses.ALERTS_CONTENT_COMPOSE_MORE_INFO,
            moreInfo && Classes.ACTIVE
          )}
        >
          This can be a hint that shows the user what to put here when they
          select the “i” button next to Message Details. On mobile, this could
          show up below the input
        </Text>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/alert-details/ipaws-details.tsx